import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, Image, NameList } from 'ui/acro'
import { TimeCodeBadge } from 'components_v2/Home/SignedIn/common/components'
import DrawerResultTitleText from './DrawerResultTitleText'
import DrawerResultSubtitleText from './DrawerResultSubtitleText'
import CommonLink from 'components_v2/CommonLink'

const ClassResultItem = ({
  id,
  textColor,
  href,
  thumbnailImage,
  title,
  humanDuration,
  coaches,
  category,
  subcategory,
  difficultyLevel
}) => {
  return (
    <Flex
      id={id}
      className='unstyled'
      to={href}
      alignItems='center'
      cursor='pointer'
      width='100%'
      as={CommonLink}
      onMouseDown={
        // Prevent onMouseDown event because onBlur is called on-mouse-down whereas click handler is on-mouse-up
        (e) => e.preventDefault()
      }
    >
      <Box position='relative' mr='1em'>
        {thumbnailImage ? (
          <Image
            src={thumbnailImage}
            objectFit='cover'
            width='95px'
            minWidth='95px'
            minHeight='95px'
          />
        ) : (
          <Box
            backgroundColor='grey1'
            width='95px'
            minWidth='95px'
            minHeight='95px'
          />
        )}
        {humanDuration && (
          <TimeCodeBadge
            fontSize='12px !important'
            bottom='8px !important'
            left='8px!important'
          >
            {humanDuration}
          </TimeCodeBadge>
        )}
      </Box>
      <Flex flexDirection='column'>
        {title && (
          <DrawerResultTitleText id='ClassTitle' color={textColor}>
            {title}
          </DrawerResultTitleText>
        )}
        {coaches && (
          <DrawerResultSubtitleText id='ClassSubitle' color={textColor}>
            {coaches[0] && coaches[0]['firstName'] !== undefined ? (
              <NameList people={coaches} />
            ) : (
              coaches.map((item, index) => {
                return (index ? ', ' : '') + item
              })
            )}
          </DrawerResultSubtitleText>
        )}
        <DrawerResultSubtitleText color={textColor}>
          {category && `${category}`}
          {subcategory && ` / ${subcategory}`}
          {difficultyLevel && ` • ${difficultyLevel}`}
        </DrawerResultSubtitleText>
      </Flex>
    </Flex>
  )
}

ClassResultItem.propTypes = {
  id: PropTypes.string,
  textColor: PropTypes.string,
  title: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  thumbnailImage: PropTypes.string.isRequired,
  humanDuration: PropTypes.string,
  coaches: PropTypes.array,
  category: PropTypes.string,
  subcategory: PropTypes.string,
  difficultyLevel: PropTypes.string
}

export default ClassResultItem
